import customerIdRegex from '@eneco/common/validation/customerIdRegex';
import { emailValidation } from '@eneco/common/validation/emailRegex';
import phoneNumberRegex from '@eneco/common/validation/phoneNumberRegex';
import * as yup from 'yup';

import type { DeceasedFormContent } from '../deceased-form-content.types';

export const getSchema = (content: DeceasedFormContent) =>
  yup.object({
    recaptchaToken: yup.string().required(),
    deceasedPostalCode: yup.string().required(content.deceasedFormFields_postalCodeFormField?.requiredMessage),
    deceasedHouseNumber: yup.string().required(content.deceasedFormFields_houseNumberFormField?.requiredMessage),
    deceasedHouseNumberSuffix: yup.string(),
    customerId: yup
      .string()
      .required(content.customerIdFormField?.requiredMessage)
      .matches(customerIdRegex, content.customerIdFormField?.validationMessage),
    deceasedDate: yup.string().required(content.deceasedDateFormField?.requiredMessage),
    endContractDate: yup.string().required(content.endContractDateFormField?.requiredMessage),
    contactSalutation: yup.string().required(content.salutationFormField?.requiredMessage),
    contactFirstName: yup.string().required(content.firstNameFormField?.requiredMessage),
    contactSurnamePreposition: yup.string(),
    contactSurname: yup.string().required(content.surnameFormField?.requiredMessage),
    contactPostalCode: yup.string().required(content.contactFormFields_postalCodeFormField?.requiredMessage),
    contactHouseNumber: yup.string().required(content.contactFormFields_houseNumberFormField?.requiredMessage),
    contactHouseNumberSuffix: yup.string(),
    contactPhoneNumber: yup
      .string()
      .matches(phoneNumberRegex, {
        excludeEmptyString: true,
        message: content.phoneNumberFormField?.validationMessage,
      })
      .required(content.phoneNumberFormField?.requiredMessage),
    contactEmail: emailValidation({
      emailMessage: content.emailAddressFormField?.validationMessage,
      requiredMessage: content.emailAddressFormField?.requiredMessage,
    }),
    changePaymentMethod: yup.string().required(content.changePaymentMethodFormField?.requiredMessage),
  });
